<div id="page-wrapper">
  <app-sandbox-banner></app-sandbox-banner>
  <app-site-header [companies]="companies"></app-site-header>
  <div id="content-wrapper">
    <div id="content-wrapper-padding">
      <!-- The signed-in client's own sandbox is being refreshed: the company is
           switched off until the copy finishes, so hold the page instead of
           letting every request fail. The banner above shows the progress and
           reloads the app when it is done. -->
      <div class="sandbox-holding" *ngIf="sandboxHolding; else routed" role="status" aria-live="polite">
        <div class="sandbox-holding__card">
          <h2 class="sandbox-holding__title">Your sandbox is being refreshed</h2>
          <p>
            The sandbox data for your company is being deleted and replaced with a fresh copy of
            your live data. This usually takes a few minutes.
          </p>
          <p class="mb-0">
            This page will come back by itself when it is done. Your live data is not affected.
          </p>
        </div>
      </div>
      <ng-template #routed>
        <router-outlet *ngIf="companyLoaded && isProfileLoaded()"></router-outlet>
      </ng-template>
    </div>
    <app-site-footer></app-site-footer>
  </div>
  <!-- AI Assistant & Knowledge Base -->
  <app-chatbot-button></app-chatbot-button>
</div>
